import {consoleFancyClient} from '@frontrow/console/src/open-api/clients'

type JobOptionsT = {
  retryFailedJobs: boolean
  scheduleAt: Date | undefined | null
}

export async function postJobs(jobs: Array<unknown>, options: JobOptionsT): Promise<unknown> {
  const {data} = await consoleFancyClient.POST('/2/console/jobs', {body: {jobs, ...options}})
  return data
}
